module.exports = __webpack_public_path__ + "img/filter_w.f7bf5ad8.svg";